
import Vue from 'vue'
import Component from 'vue-class-component'
import {State, Action, Mutation} from 'vuex-class'
import {User} from '../src/store/index'
import AuthenticationService from '@/services/AuthenticationService'

import Navbar from '@/components/Navbar.vue'
import Toolbar from '@/components/Toolbar.vue'

import frChMoment from '@/locales/moment/fr-ch'
import {INotificationService} from '@/services/NotificationService'

@Component({
  components: {
    Navbar,
    Toolbar,
  },
})
export default class App extends Vue {
  public version: string = '...'
  public environment: string = '...'

  @State('user') public user!: User
  @State('isLogged') public isLogged!: boolean

  @Action private logout!: () => void

  @Mutation private setRefreshToken: any
  @Mutation private setAccessToken: any

  private $notificationService!: INotificationService

  private readonly second = 1000
  private readonly minute = 60 * this.second
  private readonly hour = 60 * this.minute

  constructor() {
    super()
    const token = this.$store.state.accessToken
    AuthenticationService.setToken(token);

    // Default locale
    (this as any).$moment.locale('fr-ch', frChMoment)
  }

  public async tokenValidation() {
    if (this.$store.state.isLogged) {
      const response = await AuthenticationService.validateTokens()
      const tokens = response.data
      this.setRefreshToken(tokens.refresh)
      this.setAccessToken(tokens.access)
      AuthenticationService.setToken(tokens.access)
    }
  }

  public logoutAction(): void {
    this.logout()
    this.$router.push('/login')
  }

  public async beforeCreate() {

    // const appInfos = await AuthenticationService.info()
    // this.version = appInfos.data.version
    // this.environment = appInfos.data.environment
  }

  public async created() {
    try {
      // Verify if there is a valid token when the app is launched
      await this.tokenValidation()
      // Logout the user every 1 hours
      window.setInterval(this.tokenValidation, 15 * this.minute)

      const path = this.$router.currentRoute.path
      const loginPath = '/login'
      if (path !== loginPath) {
        if (
          !this.isLogged &&
          !(path.indexOf('/login-recovery') !== -1) &&
          !(path.indexOf('/reset-password') !== -1)
        ) {
          this.$router.push('/login')
        } else if (this.user.mustChangePassword) {
          this.$router.push('/change-password')
        }
      }
    } catch (error: any) {
      throw error
    }
  }
}
